import { render, staticRenderFns } from "./booksTable.vue?vue&type=template&id=0300c5a1&scoped=true"
import script from "./booksTable.vue?vue&type=script&lang=js"
export * from "./booksTable.vue?vue&type=script&lang=js"
import style0 from "./booksTable.vue?vue&type=style&index=0&id=0300c5a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0300c5a1",
  null
  
)

export default component.exports